import React, { useState,useEffect } from "react";
import { Box, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { IntegrationSystemViewModel, IntegrationSettingsViewModel } from "../../../Types/ExportTypes";

type FortnoxIntegrationProps = {
    viewModel: IntegrationSystemViewModel;
    setViewModel: React.Dispatch<React.SetStateAction<IntegrationSystemViewModel>>;
};

const FortnoxIntegration: React.FC<FortnoxIntegrationProps> = ({ viewModel, setViewModel }) => {
  const { t } = useTranslation();
    const [fromDate, setFromDate] = useState("");
    useEffect(() => {
        if (viewModel.tag !== "Fortnox") {
            setViewModel(prev => ({ ...prev, tag: "Fortnox",active:true }));
        }
    }, [viewModel.tag, setViewModel]);

    const setSetting = (key: string, value: string) => {
        setViewModel(prev => {
            const settings = prev.settings ? [...prev.settings] : [];

            const idx = settings.findIndex(s => s.key === key);

            if (idx >= 0) {
                // update existing
                settings[idx] = { ...settings[idx], value };
            } else {
                // add new
                settings.push({
                    key,
                    value,
                    integrationId: prev.id ?? null,
                });
            }

            return { ...prev, settings };
        });
    };

  return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
              fullWidth
              label={t("common.description")}
              value={viewModel.description}
              onChange={(e) => setViewModel({ ...viewModel, description: e.target.value })}
          />

          <TextField
              type="date"
              label={t("common.fetchTransactionsFrom")}
              value={fromDate}
              onChange={(e) => {
                  const newDate = e.target.value;
                  setFromDate(newDate);
                  setSetting("postingDate", newDate);
              }}
              InputLabelProps={{ shrink: true }}
          />
      
       
 

    </Box>
  );
};

export default FortnoxIntegration;
